import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "../../context/LangContext";
import { Reveal, Tag } from "./Reveal";
import { ASSETS } from "../../lib/assets";

export const Process = () => {
  const { t } = useLang();
  const scenes = [ASSETS.surveyTeam, ASSETS.siteSetup, ASSETS.protectivePainting, ASSETS.inspectionTablet];

  return (
    <section id="process" className="relative bg-brand-navy py-24 md:py-32 overflow-hidden" data-testid="process">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <Tag dark>{t.process.tag}</Tag>
          <h2 className="mt-5 font-display font-semibold text-white text-4xl sm:text-5xl lg:text-6xl max-w-4xl leading-[1.02]">
            {t.process.title}
          </h2>
          <p className="mt-6 max-w-2xl text-slate-300 text-base md:text-lg leading-relaxed">{t.process.subtitle}</p>
        </Reveal>

        <div className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {t.process.steps.map((s, i) => (
            <Reveal key={i} delay={(i % 4) * 0.1}>
              <motion.div
                whileHover={{ y: -8 }}
                transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
                className="group h-full rounded-2xl overflow-hidden border border-white/10 bg-white/[0.03]"
                data-testid={`process-step-${i}`}
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img src={scenes[i]} alt={s.t} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-brand-navy via-brand-navy/20 to-transparent" />
                  <span className="absolute top-4 left-4 font-display text-4xl font-semibold text-white/90">0{i + 1}</span>
                </div>
                <div className="p-6">
                  <h3 className="font-display text-lg font-medium text-white">{s.t}</h3>
                  <p className="mt-2 text-sm text-slate-400 leading-relaxed">{s.d}</p>
                </div>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
